import * as _ from 'lodash';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { ValueHelperState } from '../../state/value-helper';

export class ValueHelperModel {
    public constructor(
        public id: string,
        public sortField: string,
        public code: string,
        public codeLevel: string,
        public descText: string,
        public descTextLong: string,
        public werks: string,
        public vkorg: string,
        public contractCharacteristic?: string,
        public contractCharacteristicValue?: string,
    ) {}

    public static compare(firstValueHelper: ValueHelperModel, secondValueHelper: ValueHelperModel): boolean {
        return _.isEqual(firstValueHelper, secondValueHelper);
    }

    public static fromOData(data: ODataValueHelperModel): ValueHelperModel {
        return new ValueHelperModel(
            data.ID,
            data.SortField,
            data.Code,
            data.CodeLevel,
            data.DescTxt,
            data.DescTxtLong,
            data.Werks,
            data.Vkorg,
            data.ContractCharacteristic,
            data.ContractCharacteristicValue,
        );
    }

    /**
     * Wrap a naked {@link PlainValueHelper} (as returned by the value-help selectors) into a
     * {@link ValueHelperModel} instance.
     *
     * @param valueHelper the naked value helper
     * @returns the wrapped model instance
     */
    public static fromState(valueHelper: ValueHelperState): ValueHelperModel {
        return new ValueHelperModel(
            valueHelper.id,
            valueHelper.sortField,
            valueHelper.code,
            valueHelper.codeLevel,
            valueHelper.descText,
            valueHelper.descTextLong,
            valueHelper.werks,
            valueHelper.vkorg,
            valueHelper.contractCharacteristic,
            valueHelper.contractCharacteristicValue,
        );
    }
}

export interface ODataValueHelperModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.ValueHelper';
    };
    ID: string;
    Werks: string;
    Vkorg: string;
    CodeLevel: string;
    Code: string;
    DescTxt: string;
    DescTxtLong: string;
    SortField: string;
    ContractCharacteristic: string;
    ContractCharacteristicValue: string;
}
